import type {FC, ReactNode} from 'react'
import {Paper} from '@mui/material'

interface Props {
  children: ReactNode
  tone?: 'default' | 'incident'
}

const AgentBubble: FC<Props> = ({children, tone = 'default'}) => {
  return (
    <Paper
      sx={{
        p: 1,
        pb: 0.75,
        // Stretch so every agent message is a consistent full-column width — the table
        // and text grow to fill it. Only charts cap their own width (see chartPanelSx)
        // so they don't balloon on a wide / full-width screen.
        alignSelf: 'stretch',
        width: '100%',
        borderRadius: 2,
        position: 'relative',
        bgcolor: tone === 'incident' ? 'transparent' : 'primary.second',
        boxShadow: tone === 'incident' ? 'none' : undefined,
      }}
    >
      {children}
    </Paper>
  )
}
export default AgentBubble
